export type textProps = {
    productId: string;
    variantId: string;
    title?: string;
    desc?: string;
    productUrl: string;
};

export const productConf: Record<string, textProps[]> = {
    jp: [
        {
            productId: '14776030986607',
            variantId: '52158000202095',
            productUrl: 'https://jp.ecoflow.com/products/delta-3-max-plus-800w-alternator-charger',
        },
        {
            productId: '14776029217135',
            variantId: '52157995680111',
            productUrl: 'https://jp.ecoflow.com/products/delta-3-max-plus-400w-solar-panel',
        },
        {
            productId: '14776031871343',
            variantId: '52158005084527',
            productUrl: 'https://jp.ecoflow.com/products/delta-3-max-plus-extra-battery-400w-solar-panel-bundle',
        },
        {
            productId: '14776034918767',
            variantId: '52158022943087',
            productUrl: 'https://jp.ecoflow.com/products/delta-3-max-400w-solar-panel',
        },
    ],
};
